// extracted by mini-css-extract-plugin
export default {"videoblockHeaderContainer":"VideoBlock_videoblockHeaderContainer__8jabb"};